<template>
  <div class="hsHeader2 w100pc fixed">
    <div class="headerTitle">
      <van-nav-bar
        :title="pageName"
        left-text="返回"
        left-arrow
        @click-left="$router.go(-1)"
      ></van-nav-bar>
    </div>
    <div class="search">
      <van-search
        v-model="value"
        shape="round"
        background="#fff"
        :placeholder="tip ? tip : '请输入'"
        @search="onSearch"
        @clear="onSearch"
        show-action
      >
        <template #action>
          <div class="searchSlot" @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>
    <ul class="flex jc-sa tabs menuList">
      <li
        :class="['menuItem', , activeIndex === index ? 'active' : '']"
        v-for="(menu, index) in dispatchOrder"
        :key="menu.state"
      >
        <div :class="['f20']" @click="goItem(index)">
          <p class="mt-5 f12 text">{{ menu.text }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "hsHeader2",
  props: {
    keyWords: String,
    pageName: String,
    // 接受input提示信息
    tip: String,
    // tabs
    dispatchOrder: Array,
  },
  data() {
    return {
      value: "",
      currentRole: localStorage.getItem("role"),
      activeIndex: 0,
    };
  },
  watch: {},
  computed: {},
  methods: {
    onSearch() {
      this.$emit("updatekeyWord", this.value);
    },
    goItem(index) {
      this.activeIndex = index;
      this.value = "";
      this.$emit("updataState", this.dispatchOrder[index].state);
    },
  },
  mounted() {},
};
</script>

<style lang="less" scope>
.hsHeader2 {
  background-color: #44b1f9;
  height: 143px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding-top: 10px;
  z-index: 3;
  .headerTitle {
    font-size: 16px;
    text-align: center;
    // line-height: 25px;
    margin-bottom: 15px;
    // height: 25px;
    color: #fff;
    .van-nav-bar {
      height: 40px;
      background-color: #44b1f9;
      .van-nav-bar__content {
        height: 40px;
      }
    }
    .van-nav-bar .van-icon {
      color: #fff;
    }
    .van-nav-bar__text {
      color: #fff;
    }
    .van-nav-bar__title {
      color: #fff;
    }
    .van-hairline--bottom::after {
      width: 0;
    }
  }
  .search {
    background-color: #44b1f9;
    padding: 0 15px;
    margin-bottom: 17px;
  }
  .tabs {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
  }
  .menuItem {
    width: 90px;
    // background-color: rgba(0,0,0,);
    padding: 10px 0;
    position: relative;
    &.active {
      &::after {
        content: "";
        display: block;
        width: 40px;
        height: 2px;
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -20px;
        background-color: #fff;
      }
    }
    .text {
      font-size: 14px;
      text-align: center;
      color: #fff;
    }
  }
}
</style>
<style lang="less">
.hsHeader2 {
  .van-search {
    padding: 0;
    padding-right: 3px;
    border-radius: 15px;
  }
  .van-search__action {
    width: 65px;
    height: 28px;
    background: #44b1f9;
    border-radius: 28px;
    text-align: center;
    line-height: 28px;
    color: #fff;
    padding: 0;
  }
}
</style>
